import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../rootReducer';
import { updateAccountActiveStatusBulk } from './updateAccountActiveStatusBulk.thunks';

export interface FormState {
  loading: boolean;
  error: string | null;
}

export const initialState: FormState = {
  error: null,
  loading: false
};

const getForm = (state: RootState): FormState => state.users.form;

export const selectors = {
  getForm
};

const extraReducers = {
  [updateAccountActiveStatusBulk.pending.type]: (state: FormState): void => {
    state.loading = true;
    state.error = null;
  },
  [updateAccountActiveStatusBulk.fulfilled.type]: (state: FormState): void => {
    state.loading = false;
  },
  [updateAccountActiveStatusBulk.rejected.type]: (state: FormState, action: PayloadAction<string>): void => {
    state.loading = false;
    state.error = action.payload;
  }
};

const bulkSlice = createSlice({
  name: 'activeStatusBulk',
  initialState,
  reducers: {},
  extraReducers
});

export default bulkSlice.reducer;

export const actions = bulkSlice.actions;
export const caseReducers = bulkSlice.caseReducers;
